import React from "react";
import { styleBlock } from "../styleBlock";
import { Card } from "react-bootstrap";
export default class LinkList extends React.PureComponent {
    render() {
        const { title, links, className } = this.props;
        const classNames = styleBlock("linklist");
        const cn = classNames({}).mix(className);
        return (React.createElement(Card, { className: cn.toString() },
            React.createElement(Card.Body, null,
                title && React.createElement("h2", { className: "display-2 mb-3" }, title),
                links && React.createElement("div", { className: classNames("container") }, links.map(link => link)))));
    }
}
//# sourceMappingURL=index.js.map